import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import ColumnButton from "src/components/Page/GridButtons/ColumnButton";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import {
  deleteSupplierTypeSaga,
  getSupplierTypeDetailsSaga,
  getSupplierTypeListSaga,
} from "src/store/supplier-types/saga";
import {
  SupplierTypeDetailDto,
  SupplierTypeDto,
} from "src/store/supplier-types/type";
import SupplierTypeCreateForm from "./create";
import SupplierTypeEditForm from "./edit";
const SupplierTypePage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState<SupplierTypeDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<SupplierTypeDetailDto>();
  const columns = [
    {
      text: t("SupplierType.Name"),
      dataField: "Name",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("SupplierType.PageTitle")}
        metaTag={t("SupplierType.MetaTag")}
        gridProps={{
          addTitle: t("SupplierType.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getSupplierTypeListSaga,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getSupplierTypeDetailsSaga({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          deleteButton: {
            text: (id, data: SupplierTypeDto) =>
              t("SupplierType.DeleteQA", {
                name: data.Name,
              }),
            action: deleteSupplierTypeSaga,
            onClick: (id, data) => setShowEdit(data),
          },
        }}
      />
      <SupplierTypeCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getSupplierTypeListSaga,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <SupplierTypeEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getSupplierTypeListSaga,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default SupplierTypePage;
